import React, { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import { PageTitle } from "../../../_metronic/layout/core";
import { SalePrintSummary } from "./SalePrintSummary";
import BedRockContext from "../../BedRockContext";

export function SalePrintSummaryPage() {
    const { id } = useParams();
    const myData = useContext(BedRockContext);

    // Reset toolbar buttons when entering this page
    useEffect(() => {
        myData.setBaseData({ toolBarButtons: [] });
    }, []);

    const breadcrumbs = [
        {
            title: "Home",
            path: "/dashboard",
            isSeparator: false,
            isActive: false,
        },
        {
            title: "",
            path: "",
            isSeparator: true,
            isActive: false,
        },
        {
            title: "Sales",
            path: "/sales-list",
            isSeparator: false,
            isActive: false,
        },
        {
            title: "",
            path: "",
            isSeparator: true,
            isActive: false,
        },
    ];

    return (
        <>
            <PageTitle breadcrumbs={breadcrumbs}>Sale Receipt</PageTitle>
            <SalePrintSummary id={id} />
        </>
    );
}
